import {
  Accordion,
  Box,
  BoxProps,
  Grid,
  GridProps,
  InputBase,
  Stack,
  TextField,
  TextFieldProps,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const CreateContentModalBox = styled(Stack)(({ theme }) => ({
  alignItems:" flex-end",
  background: theme.customColors.backgroundCard,
  borderRadius:"8px",
  flexDirection: "column",
  gap: "24px",
  maxHeight:"calc(100% - 32px)",
  overflowX: "hidden",
  overflowY: "auto",
  padding:"1.5rem",

  [theme.breakpoints.down("sm")]:{
    padding:" 16px 20px"
  },

  "&:hover": {
    "&::-webkit-scrollbar-thumb":{
      backgroundColor: theme.customColors.backgroundSecondary
    }
  },
  "::-webkit-scrollbar": {
    width: "0.25rem"
  },
  "::-webkit-scrollbar-thumb":{
    backgroundColor: "transparent",
    borderRadius: "8px"
  },

  "& .editor-container": {
    backgroundColor: theme.customColors.backgroundSecondary,
    borderRadius: "2px",
    color: "black",
    padding: "0 16px 16px"
  },

  "& .rdw-editor-toolbar": {
    border: "none",
    margin: "0px",
    padding: "16px 0px"
  },

  "& .rdw-option-wrapper": {
    border: "none"
  },

  "& .rdw-editor-main": {
    height: "200px",

    "&:hover": {
      "&::-webkit-scrollbar-thumb":{
        backgroundColor: theme.customColors.border
      }
    },
    "::-webkit-scrollbar": {
      width: "6px"
    },
    "::-webkit-scrollbar-thumb":{
      backgroundColor: "transparent",
      borderRadius: "8px"
    }
  },

  ".public-DraftStyleDefault-block": {
    margin: "0px"
  }

}));

export const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.8756rem",
  fontStyle: "normal",
  fontWeight: "400",
  textAlign: "left"
}));

export const TextContent = styled(Box)(({ theme }) => ({
  display:"flex",
  flexDirection:"column",
  gap:"8px",
  textAlign: "center",

  [theme.breakpoints.down("sm")]:{
    width: "100%"
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "1.5rem",
  fontStyle: "bold",
  fontWeight: "700",
  textAlign: "left"
}));

export const ForbiddenLabelTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textWarning,
  fontSize: "10px",
  fontWeight: "700"
}));

export const TitleInputBase = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    backgroundColor: theme.customColors.backgroundSecondary,
    borderRadius:"8px",
    color: theme.customColors.textInput,
    gap:theme.spacing(1),
    padding: theme.spacing(1, 2),

    [theme.breakpoints.down("sm")]:{
      fontSize:"14px",
      width: "100%"
    },

    "&::placeholder ":{
      color:theme.customColors.backgroundDisabled,
      fontFamily:"Inter",
      fontWeight:400,
      lineHeight: "21px",
      opacity:1,

      [theme.breakpoints.down("sm")]: {
        fontSize:"14px",
        lineHeight: "8px",
        width: "100%"
      }

    }
  },
  width: "100%"
}));

export const BodyInputBase = styled(TextField)<TextFieldProps &
{
  hasMinHeight?:boolean
  maxHeight?:string
}>((
  {
    hasMinHeight = true,
    maxHeight = false,
    theme
  }) => ({
  ".MuiInputBase-root":{
    ".MuiOutlinedInput-notchedOutline":{
      border: "none !important"
    },
    border:0,
    borderRadius:"2px",
    height: hasMinHeight ? "200px" : undefined,
    maxHeight:!hasMinHeight ? "200px" : undefined,
    padding:0
  },

  "& .MuiInputBase-input": {
    backgroundColor: theme.customColors.backgroundSecondary,
    borderRadius: "0.5rem",
    border: "2px solid",
    boxSizing:"border-box",
    color: theme.customColors.textInput,
    height: hasMinHeight ? "100% !important " : undefined,
    maxHeight: maxHeight ?? "100% !important",
    overflowY:"auto !important",
    padding: theme.spacing(1, 2),
    "&:focus": {
      border: `2px solid ${theme.customColors.accentVariantA} !important`
    },

    [theme.breakpoints.down("sm")]:{
      fontSize:"14px",
      width: "100%"
    },

    "&::placeholder ":{
      color:theme.customColors.backgroundDisabled,
      fontFamily:"Inter",
      FontSize:"14px",
      fontWeight:400,
      lineHeight: "21px",
      opacity:1,

      [theme.breakpoints.down("sm")]: {
        fontSize:"14px",
        width:"100%"
      }
    }
  },
  width: "100%"
}));

export const ContentBox = styled(Stack)(({ theme }) => ({
  display:"flex",

  [theme.breakpoints.down("sm")]:{
    width: "100%"
  }
}));

export const AttachmentsBox = styled(Stack)(({ theme }) => ({
  background:theme.linearGradients.gradientB,
  borderRadius:"4px",
  boxShadow: "50px 50px 80px 0px rgba(0, 0, 0, 0.40)",
  display:"flex",
  flexDirection:"row",
  gap: "24px",
  justifyContent:"space-between",
  marginBottom:"24px",
  marginTop: "16x",
  [theme.breakpoints.down("sm")]:{
    marginRight:theme.spacing(2)
  }

}));

export const UploadAttachmentsBox = styled(Box)<
  BoxProps
  >(() => ({
    backgroundPositionX: "center",
    backgroundPositionY: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius:"4px 0px 0px 4px",
    height:"80px",
    position:"relative",
    width:"80px"
  }));

export const TagBox = styled(Stack)(() => ({
  alignItems:"center",
  background:"rgba(10, 13, 21, 0.60)",
  border: "1px solid #FFF",
  borderRadius:"4px",
  display:"flex",
  flexDirection:"row",
  gap:"8px",
  justifyContent:"space-between",
  padding: "8px",
  width: "auto"
}));

export const InsertUrl = styled(Grid)<GridProps>(({ theme }) => ({
  background:theme.linearGradients.gradientB,
  borderRadius:"4px",
  boxShadow: "50px 50px 80px 0px rgba(0, 0, 0, 0.40)",
  flexDirection: "row",
  gap: "24px",
  padding:" 24px 40px",
  width:"auto"
}));

export const ResultsStack = styled(Stack)<{$isVisible?:boolean}>(({ theme, $isVisible=true }) => ({
  backgroundColor: theme.customColors.backgroundSecondary,
  borderRadius: $isVisible? "2px" :"10%",
  bottom: theme.spacing(-1),
  boxShadow:"2px 2px 16px rgba(0, 0, 0, 0.4)",
  gap: "8px",
  opacity:$isVisible ? 1 : 0,
  padding: "8px 16px",
  pointerEvents:$isVisible ? "auto" : "none",
  position: "absolute",
  transform: $isVisible ? "translateY(100%) scale(1)" : " translateY(100%) scale(0.5)",
  transition:  "all .2s linear" ,
  width: "88.35%",
  zIndex: $isVisible ?  theme.zIndex.mobileStepper : 0
}));

export const TagTypography = styled(Typography)<{$disabled: boolean}>(({ theme, $disabled }) => ({
  color: $disabled ? theme.customColors.textDisabled : theme.palette.common?.black,
  cursor: "pointer",
  fontSize: "1rem",
  fontWeight: "400",
  lineHeight: "1.5"
}));

export const UserInfoBox = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  margin: "24px 0"
}));

export const UserNameTypography = styled(Typography)(() => ({
  fontSize: "14px",
  fontStyle: "bold",
  fontWeight: "700",
  lineHeight: "1.2rem"
}));

export const LinkAccordion = styled(Accordion)(({ theme }) => ({
  background: "transparent",
  borderColor: theme.palette.divider,
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: "12px !important",
  boxShadow: "none",
  color: theme.customColors.textWidget,
  margin: "0 !important",
  "&:before": {
    content: "none"
  },
  ".MuiAccordionSummary-root": {
    minHeight: "unset",
    padding: theme.spacing(2),
    ".MuiAccordionSummary-expandIconWrapper": {
      transition: "all .3s linear"
    },
    "& .MuiAccordionSummary-content": { margin: 0 }
  },
  ".MuiAccordionDetails-root": {
    padding: theme.spacing(0, 2, 2)
  }
}));

export const StyledError = styled(Box)(({ theme }) => ({
  alignItems:"center",
  alignSelf:"flex-start",
  justifyContent:"center",
  color:theme.customColors.textWarning,
  display:"flex",
  gap:theme.spacing(2),
  maxWidth:"582px"
}));
